import type { FC } from 'react';

import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { SearchBrandListFragmentFragmentDoc } from '@packages/gql/generated/shopping/SearchBrandListFragmentFragmentDoc';

import { BrandListQuickLinks } from '../BrandListQuickLinks';
import { BrandListItem } from '../BrandListItem';

/* GraphQL */ `
  fragment SearchBrandListFragment on SearchBrand {
    title
    ...SearchBrandListItemFragment
  }
`;

export type BrandListProps = {
  maskedBrands: FragmentType<typeof SearchBrandListFragmentFragmentDoc>[];
};

/**
 * List component for brands page
 * */
export const BrandList: FC<BrandListProps> = ({ maskedBrands }) => {
  const brands = maskedBrands.map((maskedBrand) =>
    getFragmentData(SearchBrandListFragmentFragmentDoc, maskedBrand),
  );

  const groupNames = brands.map((brand) => brand.title);

  return (
    <>
      <BrandListQuickLinks groupNames={groupNames} />
      {brands.map((brand) => (
        <BrandListItem key={brand.title} maskedBrand={brand} />
      ))}
    </>
  );
};
